export default __webpack_public_path__ + "static/media/interior7.56003ea0.webp";